import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import NoPlanIcon from "@/components/Icons/NoPlanIcon";

interface EmptyPlanProps {
  planType: string;
}

const useStyles = makeStyles()(() => ({
  noPlanIcon: {
    width: "71px",
    height: "71px",
    alignSelf: "center",
  },
}));

const EmptyPlan: React.FC<EmptyPlanProps> = ({ planType }) => {
  const { classes } = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      marginTop="24px"
    >
      <NoPlanIcon className={classes.noPlanIcon} />
      <Typography variant="subtitle1" color="textSecondary" textAlign="center">
        No {planType} plan created
      </Typography>
    </Box>
  );
};

export default EmptyPlan;
